import { createAction, createStandardAction } from 'typesafe-actions';
import { AuthErrorInfo, TokenSet} from './Types';

export const loginUserRequest = createAction('@@auth/LOGIN_USER_REQUEST');
export const loginUserSuccess = createStandardAction('@@auth/LOGIN_USER_SUCCESS')<TokenSet>();
export const loginUserFailure = createStandardAction('@@auth/LOGIN_USER_FAILURE')<AuthErrorInfo>();
export const surveyFollowupRequest = createAction('@@auth/SURVEY_FOLLOWUP_REQUEST');
export const surveyFollowupSuccess = createAction('@@auth/SURVEY_FOLLOWUP_SUCCESS');
export const surveyFollowupFailure = createStandardAction('@@auth/SURVEY_FOLLOWUP_FAILURE')<AuthErrorInfo>();
export const logoutUserSuccess = createAction('@@auth/LOGOUT_USER');
export const getnewAccessTokenRequest = createAction('@@auth/GET_NEW_ACCESS_TOKEN_REQUEST');
export const getnewAccessTokenSuccess = createStandardAction('@@auth/GET_NEW_ACCESS_TOKEN_SUCCESS')<TokenSet>();
export const getnewAccessTokenFailure = createStandardAction('@@auth/GET_NEW_ACCESS_TOKEN_FAILURE')<AuthErrorInfo>();
export const useNewAccessTokenFailure = createStandardAction('@@auth/USE_NEW_ACCESS_TOKEN_FAILURE')<AuthErrorInfo>();
